import { css } from 'styled-components';
import { media, themeGet, isNot } from '@packages/ui';

const SIDEBAR_WIDTH_LG_HALF = 300 / 2;
const getCmsModuleMargin = (props) => props?.theme?.content?.cmsModuleMargin;

export const moduleMargin = (props: any) => {
  if (getCmsModuleMargin(props)) {
    return css<any>`
      margin: 0 ${themeGet.space(2)};

      ${media.from.md`
        margin: 0 ${themeGet.space(3)};
      `};

      ${isNot('isCategoryPage')`
        ${media.from.lg`
            margin: 0 ${SIDEBAR_WIDTH_LG_HALF}px;
        `};
      `};
    `;
  }

  return '';
};
